<template>
    <header class="header-cmp">
        <a-icon
            :type="aside_collapsed ? 'menu-unfold' : 'menu-fold'"
            @click="setCollapsed"
        ></a-icon>
        <div class="header-right">
            <div v-if="userInfo.name == '桐庐政府'" class="mr8" @click="goScreen"><span>数据大屏</span> &nbsp;|</div>
            <div>
                <!-- <router-link to="/sparkonto">账户</router-link> |  -->
                <span>{{ userInfo.name }}</span> &nbsp;|
                <!-- {{ userInfo.name }} | -->
            </div>
            <img class="ml8" src="../../assets/loginOut.png" alt="" @click="logout" />
        </div>
    </header>
</template>

<script type="text/javascript">
import { mapMutations, mapGetters } from "vuex";
import UserInfoTool from "../../plugins/user-info-tool";

export default {
    name: "header-component",
    props: {
        module: {
            type: String,
            default: "admin",
        }
    },
    inject: ["reload"],
    data() {
        return {
            stationList: [],
            userInfo: JSON.parse(localStorage.user)
        };
    },
    computed: {
        ...mapGetters(["aside_collapsed"])
    },
    methods: {
        ...mapMutations({
            set_collapsed: "ASIDE_COLLAPSE"
        }),

        setCollapsed() {
            this.set_collapsed(!this.aside_collapsed);
        },
        logout() {
            this.$api.common
                .logout({
                    body: this.$qs.stringify({})
                })
                .then(res => {
                    this.$router.push({
                        name: "login"
                    });
                    localStorage.clear();
                });
        },
        // 跳转到数据大屏
        goScreen() {
            this.$api.common.getScreenCode({verifyCode: '05ba79Abbe56E057'}).then(res => {
                console.log(res)
                if(!res.data.error_no){
                    window.open("https://customerh5.jiabaotu.com/tl_datastatisticScreen/#/?verifyToken=" + res.data.verifyToken);
                }
            })
            
        }
    },
    created() {},
    mounted() {}
};
</script>

<style rel="stylesheet/scss" lang="scss">
.header-cmp {
    z-index: 10;
    height: 64px;
    background: #002140;
    box-shadow: 0 1px 4px 0 rgba(0, 21, 41, 0.12);
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px;

    .station-selector {
        &-select {
            width: 220px;
        }
    }
    .anticon {
        font-size: 20px;
        cursor: pointer;
    }
    .anticon-menu-fold,.anticon-menu-unfold{
        color: #fff;
    }
}

.header-right {
    display: flex;
    align-items: center;
    color: #fff;
    cursor: pointer;
    img {
        width: 24px;
        height: 24px;
        // border-radius: 50%;
        // margin-left: 8px;
        // background: #fff;
    }
    .router-link-exact-active,
    a {
        color: #fff;
    }
}
</style>
